















































import { defineComponent } from '@vue/composition-api';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import TrashIcon from '@front-app/components/icons-old/Trash.vue';
import { Size } from '@front-app/components/constants';

export default defineComponent({
	components: {
		CtaButton,
		TrashIcon,
	},
	props: {
		title: {
			type: String,
			default: '',
		},
		hideActions: Boolean,
	},
	setup() {
		return {
			Size,
			ButtonPalettes,
		};
	},
});
